module.exports = __webpack_public_path__ + "static/media/10.29379bd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/10.svg
// module id = 416
// module chunks = 14